export const copyRight = '© Ellen MacArthur Foundation';

export const description =
  'La Fundación Ellen MacArthur trabaja para acelerar la transición hacia una economía circular. Desarrollamos y promovemos el concepto de economía circular y colaboramos con empresas, universidades, responsables de políticas públicas e instituciones para movilizar soluciones sistémicas a gran escala a nivel global.';

export const registrationNumbers = [
  'Número de Registro Benéfico (Inglaterra y Gales): 1130306',
  'Registro OSCR (Escocia): SC043120',
  'Número de Empresa: 6897785',
  'Fundación Ellen MacArthur ANBI RSIN (Países Bajos): 8257 45 925',
];

export const primaryLinks = [
  {
    title: 'Sobre nosotros',
    url: `/es/sobre-nosotros/que-hacemos`,
  },
  {
    title: 'Nuestra red',
    url: `/es/nuestra-red/vision-general`,
  },
  {
    title: 'Carreras',
    url: `/es/carreras/vision-general`,
  },
  {
    title: 'Contacto',
    url: `/es/contacto`,
  },
  {
    title: 'Regiones',
    url: `/es/regiones/vision-general`,
  },
  {
    title: 'Sala de prensa',
    url: `/es/sala-de-prensa/vision-general`,
  },
];

export const secondaryLinks = [
  // Optional - currently all links fit in one column
];

export const subContentLinks = [
  {
    title: 'Políticas',
    url: '/policies',
  },
  {
    title: 'Cookies',
    url: '/cookies',
  },
];

export const partners = {
  text: 'El trabajo de la Fundación Ellen MacArthur es apoyado por nuestros ',
  linkText: 'Socios y Socios estratégicos.',
  linkUrl: '/es/nuestra-red/vision-general',
};

export const socialLinks = [
  {
    type: 'linkedIn',
    alt: 'Enlace a la página de LinkedIn de EMF. Se abre en una nueva pestaña.',
    url: 'https://uk.linkedin.com/company/ellen-macarthur-foundation',
  },
  {
    type: 'youTube',
    alt: 'Enlace a la página de YouTube de EMF. Se abre en una nueva pestaña.',
    url: 'https://www.youtube.com/user/made2bemadeagain',
  },
  {
    type: 'instagram',
    alt: 'Enlace a la página de Instagram de EMF. Se abre en una nueva pestaña.',
    url: 'https://www.instagram.com/fundacionellenmacarthur/',
  },
  {
    type: 'medium',
    alt: 'Enlace a la página de Medium de EMF. Se abre en una nueva pestaña.',
    url: 'https://medium.com/@circulareconomy',
  },
];

export const poweredByContentful = {
  text: 'Powered by Contentful',
  url: 'https://www.contentful.com/',
};
